import React, { useEffect, useContext, useState } from 'react';
import $ from 'jquery';
import DataTable from 'datatables.net';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Menusup from '../../componentes/menus/menusup/Menusup';
import Sidebar from '../../componentes/menus/sidebar/Sidebar';
import Footer from '../../componentes/footer/Footer';
import Section from '../../componentes/ui/Section';
import MiDataTable from '../../componentes/ui/MiDataTable';
import MiDataTableEdiRap from './MiDataTableEdiRap';
import PermissionRefused from '../../componentes/ui/PermissionRefused';
import LoadingPage from '../../componentes/ui/LoadingPage';
import Kpi from '../../componentes/ui/Kpi';
import Button from '../../componentes/ui/Button';
import ButtonOutline from '../../componentes/ui/ButtonOutline';
import MiSelect from '../../componentes/formulario/MiSelect';
import FormInput from '../../componentes/formulario/FormInput';
import { Spinner } from 'react-bootstrap';
import SpinnerFloat from '../../componentes/ui/SpinnerFloat';
import swal from 'sweetalert';
import { Modal } from 'react-bootstrap';
import TextArea from '../../componentes/formulario/TextArea';
import { alertService } from '../../services/alertservice';
import { Alert } from '../../componentes/ui/Alert';
import MiSelectLarge from '../../componentes/formulario/MiSelectLarge';
import UplmPlusBtn from '../../componentes/formulario/UpmlPlusBtn/UplmPlusBtn';

import useLogicForm from '../../hooks/useLogicForm';

import Cookies from 'universal-cookie';

import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getAhorayyyymmdd, getPantDocFromNivel, setStockOptionsSelectUbi, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';

import { Fragment } from 'react';
import FormRow from '../../componentes/formulario/FormRow';
import { NavLink } from 'react-router-dom';

$.DataTable = DataTable;
let backUpOptionsUbi;
const url = window.location;

function Edirap(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    // ***** Context *****
    const { validateSesion, socket, confApp, saveConfApp, getConfApp, apiKey, appCryptCom } = useContext(LoginContext);    

    // ***** State para la configuración de la pantalla *****
    const [ confPantalla, saveConfPantalla ] = useState(confApp)
    const [ loadedConf, saveLoadedConf ] = useState(false);
    const [ tieneNivel, saveTieneNivel ] = useState(true);
    const [ documentos, saveDocumentos ] = useState([])
    const [ lineas, saveLineas ] = useState([]);
    const [ loadingCalculate, saveLoadingCalculate ] = useState(false);
    const [ optionsUbi, saveOptionsUbi ] = useState([]);
    const [ optionsUbiAddForm, saveOptionsUbiAddForm ] = useState([]);
    const [ loadingSelectUbiAddForm, saveLoadingSelectUbiAddForm ] = useState(false);
    const [ loadedSelect, saveLoadedSelect ] = useState(false);
    const [ optionsUni, saveOptionsUni ] = useState([]);
    const [ idFiltro, saveIdFiltro ] = useState(0);
    const [ idParam, saveIdParam ] = useState(null);
    const [ infoDoc, saveInfoDoc ] = useState("");
    const [ idDocActual, saveIdDocActual ] = useState(null);
    const [ idDocActualTabla, saveIdDocActualTabla ] = useState(null);
    // const [ unidad, saveUnidad ] = useState(0);
    const [ unidad, saveUnidad ] = useState({value: 0, label: ""});
    const [ cantidad, saveCantidad ] = useState(0);
    // const [ ubicacion, saveUbicacion ] = useState(0);
    const [ ubicacion, saveUbicacion ] = useState({value: 0, label: ""});
    const [ reloadKpi, saveReloadKpi ] = useState(0);
    const [ showModalEditCabecera, saveShowModalEditCabecera ] = useState(false);
    const [ idestCab, saveIdEstCab ] = useState();
    const [ nom1Cab, saveNom1Cab ] = useState();
    const [ nom1EnCab, saveNom1EnCab ] = useState();
    const [ fec1Cab, saveFec1Cab ] = useState();
    const [ fec2Cab, saveFec2Cab ] = useState();
    const [ fec3Cab, saveFec3Cab ] = useState();
    const [ notasCab, saveNotasCab ] = useState();
    const [ notasEnCab, saveNotasEnCab ] = useState();
    const [ loadingActionModal, saveLoadingActionModal ] = useState(false);    
    const [ showModalEditLinea, saveShowModalEditLinea ] = useState(false);
    const [ idLin, saveIdLin ] = useState();
    const [ idestLin, saveIdEstLin ] = useState();
    const [ num3Lin, saveNum3Lin ] = useState();
    const [ nom1Lin, saveNom1Lin ] = useState();
    const [ nom1EnLin, saveNom1EnLin ] = useState();
    const [ fec1Lin, saveFec1Lin ] = useState();
    const [ fec2Lin, saveFec2Lin ] = useState();
    const [ fec3Lin, saveFec3Lin ] = useState();
    const [ notasLin, saveNotasLin ] = useState();
    const [ notasEnLin, saveNotasEnLin ] = useState();
    const [ docBloqueado, saveDocBloqueado ] = useState(false);
    const [ adjuntos, saveAdjuntos ] = useState([]);
    const [ adjuntosCabecera, saveAdjuntosCabecera ] = useState([]);

    // ***** Custom Hook - Lógica de los formularios *****
    const { registrosPrin, saveRegistrosPrin, formularioPrin, saveFormularioPrin, adjuntosPrin, saveAdjuntosPrin, adjuntosExistentesPrin, saveAdjuntosExistentesPrin, registrosHijo,  formularioHijo, saveFormularioHijo, adjuntosHijo, saveAdjuntosHijo, adjuntosExistentesHijo, saveAdjuntosExistentesHijo, handleInputForm, handleLastReg, handleEditRegPrin, loadingTable, saveLoadingTable, loadReg, saveLoadReg, regIniciales, handleEditRegHijo, handleDeleteItemPrin, handleDeleteItemHijo, handleSubmitPrin, handleSubmitHijo, resetFormPrin, resetFormHijo, handleSelectFormPrin, handleSelectFormHijo, handleSelectFormPrinAndSetValue, handleSelectFormHijoAndSetValue, handleClonePrin, handleCloneHijo } = useLogicForm();

    useEffect( () => {        
        
        // ***** Validamos que el usuario esté logueado sino lo enviamos al login*****
        validateSesion(props)
            .then( (respuesta) => {
                if( confPantalla === undefined ){
                    return getConfApp();
                }else{ 
                    document.title = getTitle(confPantalla.config.trad, confPantalla.edirap.title);                    
                    if( respuesta == 1 ){
                        saveTieneNivel(true);
                        // Seleccionar los parámetros que nos llegan por la url
                        if( props.location.state ){
                            if( "iddoc" in props.location.state ){
                                // Nos llega el documento como parámetro                                    
                                saveIdParam(props.location.state.iddoc);
                                saveIdDocActual(props.location.state.iddoc); 
                                handleGetLineas(props.location.state.iddoc);                               
                            }                               
                        }                                       
                        init();          
                    }
                    else if( respuesta == 0 ){
                        saveTieneNivel(false);
                    }                    
                    saveLoadedConf(true);        
                }
            })
            .then( (respuesta) => {
                if( respuesta !== undefined  ){
                    saveConfPantalla(respuesta.msg);
                    saveConfApp(respuesta.msg);             
                }
            })          

        // Liberamos todos los registros al salir de la pantalla
        return () =>{
            if( socket != null ){
                socket.emit("salirPantalla", { "idusu": getDecodedCookie('id'), "tabla": "documentos" })
            }
                document.querySelector("body").classList.remove("sidebar-open");

                // Token cancelación axios al desmontar componentes
                source.cancel();
        } 

    },[confPantalla])


    const init = async() => {

        // Combo ubicaciones para la tabla de edicion                  
        // await loadOptionsCbo(confPantalla.edirap.controles.ubi.datatype, confPantalla.edirap.controles.ubi.data, optionsUbiAddForm, saveOptionsUbiAddForm, true);

        // Obtenemos los option para los articulos para los combos de la tabla de las líneas        
        // await loadOptionsCbo(confPantalla.edirap.controles.iduni.datatype, confPantalla.edirap.controles.iduni.data, optionsUni, saveOptionsUni);                   
        saveLoadedSelect(true);
    }



    const loadOptionsCbo = async (fuente, opcion, options, saveOptions, backUp=false) =>{
        const data = new FormData();
        data.append("validacion", apiKey());                        
        
        const idCookie = await encryptData(cookies.get('id'), appCryptCom);
        data.append('ua', idCookie);
        const nivelCookie = await encryptData(cookies.get('nivel'), appCryptCom);
        data.append('na', nivelCookie);
                    
        // Encriptamos el tag sql. 
        opcion = await encryptData(opcion, appCryptCom);
        data.append(fuente, opcion);                

        if( options == null || options.length == 0){
            let url = null;
            if( fuente == "filter" ){
                url = getApiUrl(window.location.origin)+'/filters/getFilter';
            }else{
                url = getApiUrl(window.location.origin)+'/app/getDataCbo';
            }
            const respuesta = await axios.post(url, data);
            saveOptions(respuesta.data);            
            if(backUp){
                backUpOptionsUbi = respuesta.data;
            }               
        }        
    }


    
    const handleGetLineas = async(param=null, idParam=null, datosParam=null, selectedRowsParam=null) => {        
        saveLoadingCalculate(true);        
        let table, rows, idDoc;
        let continuar = true;
        
        if( param && selectedRowsParam && selectedRowsParam.length > 0 ){

            selectedRowsParam && selectedRowsParam[0] && selectedRowsParam[0].idest == 9 ? saveDocBloqueado(true) : saveDocBloqueado(false);

            if( socket != null && socket.connected == true ){
                // Envío una consulta al servidor con mis datos y los del registro que quiero editar para consultar si esta libre
                socket.emit("regOcupado", { "url": window.location.origin, "idusu": getDecodedCookie('id'), "nombre": getDecodedCookie('nombre'), "idreg": idDoc, "tabla": "documentos"  }, (response) => {
                    if( response["response"].length > 0 ){                        
                        alertService.warn(`<i class='fal fa-exclamation-triangle mr-1'></i>${confApp.config.trad.logic.edit.busy.title} '${response["response"][0]["nombre"]}' - ${response["response"][0]["hora"]}`, {autoClose: true}); 
                        saveLoadReg(false);
                        continuar = false;
                        return;
                    }
                })  
                if(continuar == false) return;
            }
            // Obtenemos los option para las ubicaciones para los combos de la tabla con las líneas
            // await loadOptionsCbo(confPantalla.edirap.controles.idubi.datatype, confPantalla.edirap.controles.idubi.data, optionsUbi, saveOptionsUbi);

            idDoc = param.toString().includes('#row-') ? param.toString().split('-')[1] : param;
            
            saveIdDocActual(idDoc);
            saveIdDocActualTabla(idDoc);
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", JSON.stringify(idDoc));

            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.edirap.controles.datatableres.getdata, data, source.token);

            // Reseteamos la tabla de resultado
            if( typeof respuesta.data !== "string" ){
                saveLineas(respuesta.data);
                table = $("#edirap").DataTable();
                rows = table.rows().data();
                for(let i=0; i < rows.length; i++){
                    if( rows[i].id == idDoc ){
                        table.row(':eq('+i+')', { page: 'current' }).select();
                        saveInfoDoc(rows[i]);
                    }
                }
            }else if( typeof respuesta.data === "string" ){            
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
            } 
        }else{
            table = $("#edirap").DataTable();
            rows = table.rows( { selected: true } ).data();            
            if( rows.length > 0 || param != null){
                
                if(param == null){
                    idDoc = rows[0].id;
                }else{
                    idDoc = param;
                }
                idDoc = idDoc.includes('#row-') ? idDoc.split('-')[1] : idDoc;
                
                if(!param.includes('#row-') && idParam != 'edirap'){
                    // Obtenemos los option para las ubicaciones para los combos de la tabla con las líneas
                    // await loadOptionsCbo(confPantalla.edirap.controles.idubi.datatype, confPantalla.edirap.controles.idubi.data, optionsUbi, saveOptionsUbi);            
                    saveIdDocActual(idDoc);
                    saveIdDocActualTabla(idDoc);
                    const editedDoc = await reloadDoc(idDoc);                         
                    if(editedDoc){
                        saveInfoDoc(editedDoc);                
                        const data = new FormData();      
                        data.append("validacion", apiKey());
                        data.append("iddoc", JSON.stringify(idDoc));                
                        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.edirap.controles.datatableres.getdata, data, source.token);                
                        if( typeof respuesta.data !== "string" ){
                            saveLineas(respuesta.data);
                        }else if( typeof respuesta.data === "string" ){            
                            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
                        } 
                    }                        
                }else{
                    saveIdDocActual(null);
                    saveDocBloqueado(false);
                    if( socket != null && socket.connected == true ){
                        socket.emit("resetForm", { "idusu": getDecodedCookie('id'), "tabla": "documentos" })                        
                    }
                }
            }
            // else{
            //     alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.edirap.controles.emptyclick.title}`,{autoClose: true});                
            // }  
        }

        saveLoadingCalculate(false);
    }

    const fnReloadTablaLineas = async (idDoc) => {                              
        if(idDoc){
            saveLoadingCalculate(true);
    
            const data = new FormData();      
            data.append("validacion", apiKey());
            data.append("iddoc", idDoc["iddoc"]);
            const respuesta = await axiosPost(getApiUrl(window.location.origin)+confPantalla.edirap.controles.datatableres.getdata, data, source.token);            
            if( typeof respuesta.data !== "string" ){                               
                saveLineas(respuesta.data);                
            }else if( typeof respuesta.data === "string" ){            
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
            } 
        }
        saveLoadingCalculate(false);
    }

    const activarModoCreacion = (e, rowData) => {
      
        setTimeout((reset)=>{
            let table = $("#edirap").DataTable();
            let rows = table.rows( { selected: true } ).data();
            if( rows.length == 0 ){
                // No hay líneas seleccionadas. Reseteamos.
                saveLineas([])
                // saveUnidad(0);
                saveUnidad({value: 0, label: ""});
                saveCantidad(0);
                // saveUbicacion(0);
                saveUbicacion({value: 0, label: ""});
                saveIdDocActual(null);
                saveDocBloqueado(false)
            }
        },500)

        saveIdDocActualTabla(null);
        
    }

    const addLinea = () => {
        if( unidad != 0 ){
            if( !idFiltro && !idDocActual ){
                // Error. Debe seleccionar un tipo de documento
                alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.edirap.errortipdoc.title}`, {autoClose: false});
            }else if(idFiltro && !idDocActual){
                // Crear documento     
                saveLoadReg(true);       
                let tipo = $('#kpiTipDoc').find(':selected');
                tipo = tipo.prevObject[0].outerText;
                let ahora = getAhoraddmmyyyy()
                let text = MiReplaceAll(confPantalla.edirap.swal.text.title, "${tipo}", tipo);
                text = MiReplaceAll(text, "${ahora}", ahora);
                swal({
                    title: confPantalla.edirap.swal.title,
                    text: "",
                    content: {
                        element : "div",
                        attributes : {
                            innerHTML : `
                                        <h5>${confPantalla.edirap.swal.text.title} ${tipo}</h5>
                                        <h5>${confPantalla.edirap.swal.text2.title} ${ahora}</h5>
                                        `,
                            style : "max-width:fit-content, text-align: center"
                        }
                    },               
                    icon: "warning",
                    buttons: {
                        cancel : {text: confPantalla.edirap.swal.btncancel.title, className:'btn btn-flat mr-1 btn-outline-secondary', visible: true},
                        confirm : {text: confPantalla.edirap.swal.btnconfirm.title, className:'btn btn-flat mr-1 btn-outline-success btnSwalSuccess'},
                    } 
                }).then(confirmacion => {
                    if( confirmacion == true ){
                        accionesDoc(idDocActual, idFiltro, unidad, cantidad, ubicacion, "crear")                    
                    }else{
                        saveLoadReg(false);
                    }
                })                    
            }else{
                saveLoadReg(true);       
                // Editar documento
                accionesDoc(idDocActual, idFiltro, unidad, cantidad, ubicacion, "modificar") 
            }
        }else{
            // Error. Debe seleccionar una unidad            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confPantalla.edirap.errorunidad.title}`, {autoClose: false});
        }
    }

    const accionesDoc = async (idDocActual, idFiltro, unidad, cantidad, ubicacion, accion) => {
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("iddoc", idDocActual); 
        data.append("tipdoc", idFiltro); 
        // data.append("iduni", unidad); 
        data.append("iduni", unidad.value); 
        data.append("num1", cantidad); 
        // data.append("idubi", ubicacion);
        data.append("idubi", ubicacion.value);
        data.append("accion", accion)                    
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/edirap/actionsedirap', data);
        saveLoadReg(false);       
        if( typeof respuesta.data !== "string" ){
            let mensaje = ""
            if( accion == "crear"  ){
                mensaje = confPantalla.edirap.docsuccess.title;
                // if( socket != null && socket.connected == true ){
                //     // Envío una consulta al servidor con mis datos y los del registro que quiero editar para consultar si esta libre
                //     socket.emit("regOcupado", { "url": window.location.origin, "idusu": getDecodedCookie('id'), "nombre": getDecodedCookie('nombre'), "idreg": respuesta.data, "tabla": "documentos"  }, (response) => {                        
                //         if( response["response"].length > 0 ){
                //             alertService.warn(`<i class='fal fa-exclamation-triangle mr-1'></i>${confApp.config.trad.logic.edit.busy.title} '${response["response"][0]["nombre"]}' - ${response["response"][0]["hora"]}`, {autoClose: true}); 
                //             saveLoadReg(false);
                //             return;
                //         }
                //     })  
                // }
            }else{
                mensaje = confPantalla.edirap.linesuccess.title;
            }
            // saveUnidad(0);
            saveUnidad({value: 0, label: ""});
            saveCantidad(0);
            // saveUbicacion(0);
            saveUbicacion({value: 0, label: ""});
            saveReloadKpi(reloadKpi+1);            
            await handleGetLineas(respuesta.data, null, null, [null]);
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${mensaje}`, {autoClose: true}); 
        }else if( typeof respuesta.data === "string" ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});            
        } 
    }

    const btnEditCabecera = (e) => {
        e.preventDefault();        
        saveIdEstCab(infoDoc.idest);
        saveFec1Cab(infoDoc.fec1);
        saveFec2Cab(infoDoc.fec2);
        saveFec3Cab(infoDoc.fec3);
        saveNom1Cab(infoDoc.nom1);
        saveNom1EnCab(infoDoc.nom1_en);
        saveNotasCab(infoDoc.notas);
        saveNotasEnCab(infoDoc.notas_en);
        saveShowModalEditCabecera(true);
    }

    const accionBtnEditCabecera = async () => {

        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("id", idDocActual);
        data.append("idest", idestCab);            
        data.append("fec1", fec1Cab);
        data.append("fec2", fec2Cab);
        data.append("fec3", fec3Cab);
        data.append("nom1", nom1Cab);
        data.append("nom1_en", nom1EnCab);
        data.append("notas", notasCab);
        data.append("notas_en", notasEnCab);
        // Adjuntos existentes       
        const inputs = document.querySelectorAll('input[name*="fileExistUrl"], input[name*="fileExist"]');        
        for(let i=0; i<inputs.length; i++){
            data.append(inputs[i].name, inputs[i].value);
        }          
        
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        for(let i = 0; i < adjuntosCabecera.length; i++ ){            
            if( !adjuntosCabecera[i].urlAdd ){
                data.append(adjuntosCabecera[i]["id"]+"[]", adjuntosCabecera[i]);
            }
        }          
        const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.edirap.controles.modaleditcabecera.updatecabecera.senddata,data,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });  

        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            const editedDoc = await reloadDoc();
            saveInfoDoc(editedDoc);
            saveReloadKpi(reloadKpi+1); 
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.edirap.controles.modaleditcabecera.updatecabecera.success.title}`, {autoClose: true});
        }
        
        //Reseteamos los input de los adjuntos
        let adjs = document.querySelectorAll("input[type=file]");            
        for(let i=0; i<adjs.length; i++){
            adjs[i].value = null;
            adjs[i].files = null;
        }

        //Reseteamos los adjuntos pendientes de subir.
        saveAdjuntosCabecera([]);

        saveLoadingActionModal(false);
        saveShowModalEditCabecera(false);
    }

    const reloadDoc = async (id=null) => {
        
        let reloadedDoc = [];

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("idFiltro", idFiltro);
        data.append("idparam", id != null ? id : idDocActual);            
        data.append("reloaddoc", true);                
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+"/edirap/getdocumentosedirap", data, source.token);        
        if( typeof respuesta.data !== "string"){
            reloadedDoc = respuesta.data[0];
        }

        return reloadedDoc;
        
    }

    const btnEditLinea = (e, rowData) => {
        saveIdLin(rowData.id);
        saveIdEstLin(rowData.idest);
        saveNum3Lin(rowData.coste);
        saveFec1Lin(rowData.fec1);
        saveFec2Lin(rowData.fec2);
        saveFec3Lin(rowData.fec3);
        saveNom1Lin(rowData.descripcionlin);
        saveNom1EnLin(rowData.descripcionlin_en);
        saveNotasLin(rowData.notas);
        saveNotasEnLin(rowData.notas_en);
        saveShowModalEditLinea(true);
    }

    const accionBtnEditLinea = async () => {

        saveLoadingActionModal(true);

        const data = new FormData();      
        data.append("validacion", apiKey());
        data.append("id", idLin);        
        data.append("idest", idestLin);
        data.append("num3", num3Lin);
        data.append("fec1", fec1Lin);
        data.append("fec2", fec2Lin);
        data.append("fec3", fec3Lin);
        data.append("nom1", nom1Lin);
        data.append("nom1_en", nom1EnLin);
        data.append("notas", notasLin);
        data.append("notas_en", notasEnLin);
        // Adjuntos existentes       
        const inputs = document.querySelectorAll('input[name*="fileExistUrl"], input[name*="fileExist"]');        
        for(let i=0; i<inputs.length; i++){
            data.append(inputs[i].name, inputs[i].value);
        }          
        
        // Adjuntos nuevos datos
        const inputsNews = document.querySelectorAll('input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]');        
        for(let i=0; i<inputsNews.length; i++){
            data.append(inputsNews[i].name, inputsNews[i].value);
        } 
        // Adjuntos nuevos ficheros
        for(let i = 0; i < adjuntos.length; i++ ){            
            if( !adjuntos[i].urlAdd ){
                data.append(adjuntos[i]["id"]+"[]", adjuntos[i]);
            }
        }          
        const respuesta = await axios.post(getApiUrl(window.location.origin)+confPantalla.edirap.controles.modaleditlinea.updatelinea.senddata,data,{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });        
        if( typeof respuesta.data == "string"){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});         
        }else{
            await handleGetLineas(idDocActual, null, null, [null]);
            alertService.success(`<i class="fal fa-check-circle mr-1"></i>${confPantalla.edirap.controles.modaleditlinea.updatelinea.success.title}`, {autoClose: true});
        }
        
        //Reseteamos los input de los adjuntos
        let adjs = document.querySelectorAll("input[type=file]");            
        for(let i=0; i<adjs.length; i++){
            adjs[i].value = null;
            adjs[i].files = null;
        }

        //Reseteamos los adjuntos pendientes de subir.
        saveAdjuntos([]);

        saveLoadingActionModal(false);
        saveShowModalEditLinea(false);
    }

    const handleSelectUnidad = async (selectedItem, nameOfComponent) => {        
        // Añadimos la cantidad a los option del select de ubicaciones del formulario de añadir
        let iduni = selectedItem ? selectedItem.value : 0; 
        if(iduni > 0){
            const respuesta = await getStockOptionsSelectUbi(backUpOptionsUbi, iduni, saveLoadingSelectUbiAddForm);
            saveOptionsUbiAddForm(respuesta);
        }else{
            saveOptionsUbiAddForm(backUpOptionsUbi);
        }     

        if( selectedItem ){
            // saveUnidad(selectedItem.value) 
            saveUnidad({value: selectedItem.value, label: selectedItem.label});
        }else{
            // saveUnidad(0)
            saveUnidad({value: 0, label: ""});
        }
    }
    const handleSelectUbicacion = (selectedItem, nameOfComponent) => {

        if( selectedItem ){
            // saveUbicacion(selectedItem.value)
            saveUbicacion({value: selectedItem.value, label: selectedItem.label}); 
        }else{
            // saveUbicacion(0)
            saveUbicacion({value: 0, label: ""});
        }
    }
    const handleCantidad = (e) => {
        const { name, value } = e.target;
        saveCantidad(value)        
    }

    const handleSelectModal = (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInputModal = (e, save) => {        
        save(e.target.value)
    }

    
    return(
        <div className="App wrapper">
            <div>
                {   loadReg ?
                    <div className="alertFullWhite">
                        <Spinner animation="border" />
                    </div> 
                    :
                    null
                }
            </div>   
        {
            confPantalla !== undefined
            ?
                <Fragment>
                    <Alert fondo={true} />
                    <Menusup 
                        props = { props }
                    />
                    <Sidebar 
                        props = { props }
                    />
                </Fragment>
            :
            null
        } 
        <div className="content-wrapper">
            <div className="content-header">
            </div>
            <section className="content">                
                {
                    !tieneNivel 
                    ?
                        <PermissionRefused
                            traduction={confPantalla.config.trad.components.permissionrefused} 
                        />
                    :
                    <Fragment>
                    {
                        loadedConf === true && confPantalla !== undefined && loadedSelect == true
                        ?
                            <Section
                                tituloenhtml={true}
                                titulo={ 
                                    idDocActual == null
                                    ?
                                        confPantalla.edirap.section.titulo
                                    :
                                        infoDoc.nomdoc 
                                }  
                                icono={ confPantalla.edirap.section.icono } 
                                col={ confPantalla.edirap.section.col } 
                                idPrin={ idDocActual } 
                                borderHeader={ idDocActual != null ? infoDoc.color : null }
                                recurrencia={ idDocActual != null ? infoDoc.recurrencia : null}
                                editCabEdirap={btnEditCabecera}
                                idDocGoToRunCicCfg={ idDocActual != null ? idDocActual : null }
                                infoDocActual={infoDoc}
                                informes={confPantalla.edirap.controles.informes}
                                docBloqueado={docBloqueado}
                                origen={"edirap"}
                            >

                                <Kpi
                                    conf={ confPantalla.edirap.controles.kpi }
                                    getDataTable1 = { confPantalla.edirap.controles.datatable.getdata }
                                    saveDataTable1 = { saveDocumentos }                           
                                    saveLoadingTable = { saveLoadingTable }
                                    filtro={ confPantalla.edirap.controles.kpi.tipdoc }
                                    idFiltro={ idFiltro }
                                    saveIdFiltro={ saveIdFiltro }
                                    idParam1={ idParam }
                                    saveIdParam1={ saveIdParam }
                                    noDisplay={ idParam != null ? true : false }
                                    forceReload={props.location.state ? null : reloadKpi}
                                />

                                <MiDataTable 
                                    estadoForm= { "" }
                                    formulario={ {id:0} }
                                    id={"edirap"}
                                    columnas={confPantalla.edirap.controles.datatable.columns}
                                    data={documentos}
                                    buttons={confPantalla.edirap.controles.datatable.buttons}
                                    ordering={confPantalla.edirap.controles.datatable.ordering}
                                    order={confPantalla.edirap.controles.datatable.order}
                                    searching={confPantalla.edirap.controles.datatable.searching}
                                    paging={confPantalla.edirap.controles.datatable.paging}
                                    select={confPantalla.edirap.controles.datatable.select}
                                    pagelength={confPantalla.edirap.controles.datatable.pagelength}
                                    // saveLoadingTable={ saveLoadingTable }
                                    // loadingTable={loadingTable}
                                    columnactions={confPantalla.edirap.controles.datatable.columnactions.title}
                                    linkColumns={confPantalla.edirap.controles.datatable.linkColumns}
                                    traduction={confPantalla.config.trad.components.datatable}
                                    functionClickTd={ idParam == null ? activarModoCreacion : null }
                                    noDisplay={ idParam != null ? true : false }
                                    selectId={ {id:idDocActualTabla}}
                                    functionAfterSelect={handleGetLineas}                                         
                                />                                                                
                                {
                                    lineas != null && infoDoc
                                    ?
                                        <NavLink to={getPantDocFromNivel(getDecodedCookie('nivel'))+"/"+idDocActual}>
                                            {/* <hr data-content={infoDoc.equipo+" - "+infoDoc.descripcion} className="hr-titleinfwhite"></hr> */}
                                            {/* <div class="alert alert-secondary text-center" role="alert">
                                                    <h4 dangerouslySetInnerHTML={{ __html: infoDoc.nomdoc }}></h4>
                                                    <div className='text-right col-12' style={{position: 'absolute', bottom: 0, right: -10}}>
                                                        <button 
                                                            type="button" 
                                                            onClick={ e => btnEditCabecera(e) } 
                                                            className="btn btn-flat btn-outline-primary col-1 mb-1 mr-1" 
                                                            disabled={ false } 
                                                        >
                                                            <i className="fal fa-edit"></i>
                                                        </button> 
                                                    </div>
                                            </div> */}
                                        </NavLink>                                               
                                    :

                                        null
                                }
                                {   loadingCalculate ? 
                                        // <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        //     <Spinner animation="border" />
                                        // </div>
                                        <SpinnerFloat  />
                                    :
                                    null
                                }
                                {/* {
                                    documentos.length > 0
                                    ? */}
                                        <FormRow clases={"formedirap"}>                                            
                                            {/* <h4 className='col-12'>{idDocActual == null ? confPantalla.edirap.modocreacion.title :  confPantalla.edirap.modoedicion.title}</h4> */}
                                            {/* <MiSelect  
                                                estadoForm=  { "" }
                                                val=         { unidad }   
                                                loading=     { loadReg ? true : false }
                                                id=          { confPantalla.edirap.controles.iduni.id }    
                                                name=        { confPantalla.edirap.controles.iduni.name }   
                                                label=       { confPantalla.edirap.controles.iduni.label }    
                                                placeholder= { confPantalla.edirap.controles.iduni.placeholder }
                                                col=         { confPantalla.edirap.controles.iduni.col } 
                                                isClearable= { confPantalla.edirap.controles.iduni.isclearable }
                                                isSearchable={ confPantalla.edirap.controles.iduni.issearchable }
                                                dataType=    { confPantalla.edirap.controles.iduni.datatype }
                                                data=        { confPantalla.edirap.controles.iduni.data }
                                                required=    { confPantalla.edirap.controles.iduni.required } 
                                                disabled=  { docBloqueado == true && idParam == null ? "disabled" : confPantalla.edirap.controles.iduni.disabled }
                                                readOnly =   { docBloqueado == true && idParam == null ? "readonly" : confPantalla.edirap.controles.iduni.readonly }
                                                disablethisid={confPantalla.edirap.controles.iduni.disablethisid}
                                                disableids={confPantalla.edirap.controles.iduni.disableids}
                                                formulario= { {id:0} }   
                                                change= { handleSelectUnidad }

                                            /> */}
                                            <MiSelectLarge
                                                regActual={idDocActual ? idDocActual : 0}                                                                                                                    
                                                value={{value: unidad.value, label: unidad.label}}
                                                saveValue={saveUnidad}
                                                // inFormulario={ {formulario : formularioHijo, key : "iduni", keylabel: "idunilabel"} }
                                                id={confPantalla.edirap.controles.idunilarge.id}                                                
                                                label={confPantalla.edirap.controles.idunilarge.label.title}
                                                name={confPantalla.edirap.controles.idunilarge.name}   
                                                col={confPantalla.edirap.controles.idunilarge.col}
                                                confPantalla={confPantalla}
                                                dataType={confPantalla.edirap.controles.idunilarge.datatype}
                                                dataSql={confPantalla.edirap.controles.idunilarge.data}
                                                multiLinea={confPantalla.edirap.controles.idunilarge.multilinea}
                                                // unidad={unidad}
                                                minCharSearch={3}
                                                readOnly={""}
                                                styleLikeForm={true}                                                
                                            />
                                            <FormInput 
                                                estadoForm= { "" }
                                                value=      { cantidad }
                                                loading=    { loadReg ? true : false }
                                                id=         { confPantalla.edirap.controles.num1.id }   
                                                type=       { confPantalla.edirap.controles.num1.type }  
                                                name=       { confPantalla.edirap.controles.num1.name }   
                                                label=      { confPantalla.edirap.controles.num1.label }                                                       
                                                placeholder={ confPantalla.edirap.controles.num1.placeholder }    
                                                col=        { confPantalla.edirap.controles.num1.col } 
                                                required=   { confPantalla.edirap.controles.num1.required }
                                                readonly=   {  docBloqueado == true && idParam == null ? "disabled" : confPantalla.edirap.controles.num1.readonly }
                                                disabled=   {  docBloqueado == true && idParam == null ? "readonly" : confPantalla.edirap.controles.num1.disabled }
                                                alignRight= { confPantalla.edirap.controles.num1.alignRight }
                                                change=     { handleCantidad }
                                                onBlur=     {null} 
                                            />
                                            <MiSelectLarge
                                                regActual={idDocActual ? idDocActual : 0}
                                                value={ubicacion}
                                                saveValue={saveUbicacion}                                                
                                                label={confPantalla.edirap.controles.idubilarge.label.title}
                                                col={4}
                                                confPantalla={confPantalla}
                                                dataType={confPantalla.edirap.controles.idubilarge.datatype}
                                                dataSql={confPantalla.edirap.controles.idubilarge.data}
                                                multiLinea={confPantalla.edirap.controles.idubilarge.multilinea}
                                                unidad={unidad}
                                                minCharSearch={0}
                                                readOnly={docBloqueado == true ? true : false}
                                                // styleLikeForm={true}
                                            />
                                            {/* {
                                                loadedSelect
                                                ?
                                                    <MiSelect  
                                                        estadoForm=  { "" }
                                                        val=         { ubicacion }   
                                                        loading=     { loadReg  || loadingSelectUbiAddForm ? true : false }
                                                        id=          { confPantalla.edirap.controles.ubi.id }    
                                                        name=        { confPantalla.edirap.controles.ubi.name }   
                                                        label=       { confPantalla.edirap.controles.ubi.label }    
                                                        placeholder= { confPantalla.edirap.controles.ubi.placeholder }
                                                        col=         { confPantalla.edirap.controles.ubi.col } 
                                                        isClearable= { confPantalla.edirap.controles.ubi.isclearable }
                                                        isSearchable={ confPantalla.edirap.controles.ubi.issearchable }
                                                        // dataType=    { confPantalla.edirap.controles.ubi.datatype }
                                                        // data=        { confPantalla.edirap.controles.ubi.data }                                                
                                                        dataType=    { "codigo" }
                                                        data=        { optionsUbiAddForm }
                                                        required=    { confPantalla.edirap.controles.ubi.required } 
                                                        disabled=  { docBloqueado == true && idParam == null ? "disabled" : confPantalla.edirap.controles.ubi.disabled }
                                                        readOnly =   {  docBloqueado == true && idParam == null ? "readonly" : confPantalla.edirap.controles.ubi.readonly }
                                                        disablethisid={confPantalla.edirap.controles.ubi.disablethisid}
                                                        disableids={confPantalla.edirap.controles.ubi.disableids}
                                                        depends={ confPantalla.edirap.controles.ubi.depends }
                                                        formulario= { {id:0} }   
                                                        change= { handleSelectUbicacion }
                                                        modifyOptions = { setStockOptionsSelectUbi } 
                                                        selectinformes={true}                                                       
                                                    />
                                                :
                                                    null
                                            } */}
                                            <button 
                                                style={{marginTop: "32px"}} 
                                                id="btnaddline"
                                                className={"btn btn-outline-success col-md-2 col-sm-12 mb-4" } 
                                                type="button" 
                                                onClick={ addLinea } 
                                                disabled={  docBloqueado == true && idParam == null ? true : false }
                                            >
                                                <i className="fal fa-plus"></i>
                                                {confPantalla.edirap.controles.btnaddline.title}
                                            </button>                                         
                                        </FormRow>                           

                                    {/* :
                                        null
                                }                     */}
                                
                                {/* {
                                    lineas != null
                                    ? */}
                                        <MiDataTableEdiRap 
                                            estadoForm= { "" }
                                            formulario={ {id:0} }
                                            id={"ediraplineas"}
                                            columnas={confPantalla.edirap.controles.datatableres.columns}
                                            data={lineas}
                                            saveData={saveLineas}
                                            buttons={confPantalla.edirap.controles.datatableres.buttons}
                                            ordering={confPantalla.edirap.controles.datatableres.ordering}
                                            order={confPantalla.edirap.controles.datatableres.order}
                                            searching={confPantalla.edirap.controles.datatableres.searching}
                                            paging={confPantalla.edirap.controles.datatableres.paging}
                                            select={confPantalla.edirap.controles.datatableres.select}
                                            pagelength={confPantalla.edirap.controles.datatableres.pagelength}
                                            // saveLoadingTable={ saveLoadingCalculate }
                                            // loadingTable={loadingCalculate}
                                            columnactions={confPantalla.edirap.controles.datatableres.columnactions.title}
                                            linkColumns={confPantalla.edirap.controles.datatableres.linkColumns}
                                            traduction={confPantalla.config.trad.components.datatable}
                                            selectUbi={confPantalla.edirap.controles.idubi}
                                            selectUni={confPantalla.edirap.controles.iduni}
                                            inputNum1={confPantalla.edirap.controles.num1}
                                            swaldelete={confPantalla.edirap.swaldelete}  
                                            optionSelectUbi={optionsUbi} 
                                            optionSelectUni={optionsUni}
                                            idFiltro={idFiltro}
                                            editar={btnEditLinea} 
                                            confPantalla={confPantalla}
                                            docBloqueado={docBloqueado}                                           
                                            importExportFile={true}
                                            fnReloadTable={{fn: fnReloadTablaLineas, key: "iddoc"}}
                                            idRegImportExport={idDocActual ? idDocActual : null}
                                            saveLoadingTable={saveLoadingCalculate}  
                                        />        
                                    {/* :

                                        null

                                } */}
                                
                            </Section>
                        :
                            <LoadingPage />
                        }
                    </Fragment>
                }
                {
                    showModalEditCabecera == true
                    ?
                    <Modal
                        show={showModalEditCabecera}
                        onHide={ () => saveShowModalEditCabecera(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.edirap.controles.modaleditcabecera.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idestCab  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.edirap.controles.modaleditcabecera.idest.id }    
                                    name=        { confPantalla.edirap.controles.modaleditcabecera.idest.name }   
                                    label=       { confPantalla.edirap.controles.modaleditcabecera.idest.label }    
                                    placeholder= { confPantalla.edirap.controles.modaleditcabecera.idest.placeholder }
                                    col=         { confPantalla.edirap.controles.modaleditcabecera.idest.col } 
                                    isClearable= { confPantalla.edirap.controles.modaleditcabecera.idest.isclearable }
                                    isSearchable={ confPantalla.edirap.controles.modaleditcabecera.idest.issearchable }
                                    dataType=    { confPantalla.edirap.controles.modaleditcabecera.idest.datatype }
                                    data=        { confPantalla.edirap.controles.modaleditcabecera.idest.data }
                                    required=    { confPantalla.edirap.controles.modaleditcabecera.idest.required } 
                                    disabled=  { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.idest.disabled }
                                    readOnly =   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.idest.readonly }
                                    disablethisid={confPantalla.edirap.controles.modaleditcabecera.idest.disablethisid}
                                    disableids={confPantalla.edirap.controles.modaleditcabecera.idest.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdEstCab) }
                                /> 
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.fec1.id }   
                                    type=       { confPantalla.edirap.controles.modaleditcabecera.fec1.type }  
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.fec1.name }   
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.fec1.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.fec1.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.fec1.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.fec1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.fec1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec2Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.fec2.id }   
                                    type=       { confPantalla.edirap.controles.modaleditcabecera.fec2.type }  
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.fec2.name }   
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.fec2.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.fec2.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.fec2.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.fec2.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.fec2.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.fec2.disabled }
                                    change=     { e => handleInputModal(e, saveFec2Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec3Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.fec3.id }   
                                    type=       { confPantalla.edirap.controles.modaleditcabecera.fec3.type }  
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.fec3.name }   
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.fec3.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.fec3.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.fec3.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.fec3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.fec3.readonly }         
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.fec3.disabled }
                                    change=     { e => handleInputModal(e, saveFec3Cab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Cab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.nom1.id }   
                                    type=       { confPantalla.edirap.controles.modaleditcabecera.nom1.type }  
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.nom1.name }   
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.nom1.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.nom1.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.nom1.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.nom1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.nom1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Cab) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.nom1_en.id }   
                                    type=       { confPantalla.edirap.controles.modaleditcabecera.nom1_en.type }  
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.nom1_en.name }   
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.nom1_en.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.nom1_en.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.nom1_en.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.nom1_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.nom1_en.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.notas.id }   
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.notas.name }
                                    rows=       { confPantalla.edirap.controles.modaleditcabecera.notas.rows }      
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.notas.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.notas.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.notas.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.notas.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.notas.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.notas.disabled }
                                    change=     { e => handleInputModal(e, saveNotasCab) }
                                    onBlur=     {null} 
                                />                            
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasEnCab }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditcabecera.notas_en.id }   
                                    name=       { confPantalla.edirap.controles.modaleditcabecera.notas_en.name }
                                    rows=       { confPantalla.edirap.controles.modaleditcabecera.notas_en.rows }      
                                    label=      { confPantalla.edirap.controles.modaleditcabecera.notas_en.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditcabecera.notas_en.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditcabecera.notas_en.col } 
                                    required=   { confPantalla.edirap.controles.modaleditcabecera.notas_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditcabecera.notas_en.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditcabecera.notas_en.disabled }
                                    change=     { e => handleInputModal(e, saveNotasEnCab) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <UplmPlusBtn
                                idReg={idDocActual}
                                id={ confPantalla.edirap.controles.modaleditcabecera.uplmplusbtn.id }
                                getAdj={confPantalla.edirap.controles.modaleditcabecera.uplmplusbtn.getadj}
                                saveAdj={confPantalla.edirap.controles.modaleditcabecera.uplmplusbtn.saveadj}
                                estadoForm= { docBloqueado == true ? "readonly" : "" }                                    
                                col={12}
                                readonly={ confPantalla.edirap.controles.modaleditcabecera.uplmplusbtn.readonly }
                                traduction={confPantalla.config.trad.components}                                                            
                                datatable={ confPantalla.edirap.controles.modaleditcabecera.uplmplusbtn.datatable }
                                select={ confPantalla.edirap.controles.modaleditcabecera.uplmplusbtn.select }
                                noBtn={true}
                                noModal={true}
                                saveAdjuntosParam={saveAdjuntosCabecera}
                            />
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditCabecera }
                                        disabled={ docBloqueado == true ? true : false}                                        
                                >
                                    {confPantalla.edirap.controles.modaleditcabecera.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditCabecera(false) }                                        
                                >
                                    {confPantalla.edirap.controles.modaleditcabecera.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                {
                    showModalEditLinea == true
                    ?
                    <Modal
                        show={showModalEditLinea}
                        onHide={ () => saveShowModalEditLinea(false)}                            
                        aria-labelledby="example-custom-modal-styling-title"
                        centered={true}                    
                        dialogClassName="modal-90w"                                             
                    > 
                        <Modal.Header closeButton>
                            <h4>{confPantalla.edirap.controles.modaleditlinea.header.title}</h4>
                        </Modal.Header>                         
                        <Modal.Body>
                            <FormRow>
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { idestLin  }   
                                    loading=     { loadingActionModal ? true : false }
                                    id=          { confPantalla.edirap.controles.modaleditlinea.idest.id }    
                                    name=        { confPantalla.edirap.controles.modaleditlinea.idest.name }   
                                    label=       { confPantalla.edirap.controles.modaleditlinea.idest.label }    
                                    placeholder= { confPantalla.edirap.controles.modaleditlinea.idest.placeholder }
                                    col=         { confPantalla.edirap.controles.modaleditlinea.idest.col } 
                                    isClearable= { confPantalla.edirap.controles.modaleditlinea.idest.isclearable }
                                    isSearchable={ confPantalla.edirap.controles.modaleditlinea.idest.issearchable }
                                    dataType=    { confPantalla.edirap.controles.modaleditlinea.idest.datatype }
                                    data=        { confPantalla.edirap.controles.modaleditlinea.idest.data }
                                    required=    { confPantalla.edirap.controles.modaleditlinea.idest.required } 
                                    disabled=  { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.idest.disabled }
                                    readOnly =   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.idest.readonly }
                                    disablethisid={confPantalla.edirap.controles.modaleditlinea.idest.disablethisid}
                                    disableids={confPantalla.edirap.controles.modaleditlinea.idest.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelectModal(selectedItem, nameOfComponent, saveIdEstLin) }
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { num3Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.num3.id }   
                                    type=       { confPantalla.edirap.controles.modaleditlinea.num3.type }  
                                    name=       { confPantalla.edirap.controles.modaleditlinea.num3.name }   
                                    label=      { confPantalla.edirap.controles.modaleditlinea.num3.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.num3.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.num3.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.num3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.num3.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.num3.disabled }
                                    change=     { e => handleInputModal(e, saveNum3Lin) }
                                    onBlur=     {null}
                                    alignRight= { true } 
                                /> 
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec1Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.fec1.id }   
                                    type=       { confPantalla.edirap.controles.modaleditlinea.fec1.type }  
                                    name=       { confPantalla.edirap.controles.modaleditlinea.fec1.name }   
                                    label=      { confPantalla.edirap.controles.modaleditlinea.fec1.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.fec1.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.fec1.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.fec1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.fec1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.fec1.disabled }
                                    change=     { e => handleInputModal(e, saveFec1Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec2Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.fec2.id }   
                                    type=       { confPantalla.edirap.controles.modaleditlinea.fec2.type }  
                                    name=       { confPantalla.edirap.controles.modaleditlinea.fec2.name }   
                                    label=      { confPantalla.edirap.controles.modaleditlinea.fec2.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.fec2.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.fec2.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.fec2.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.fec2.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.fec2.disabled }
                                    change=     { e => handleInputModal(e, saveFec2Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { fec3Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.fec3.id }   
                                    type=       { confPantalla.edirap.controles.modaleditlinea.fec3.type }  
                                    name=       { confPantalla.edirap.controles.modaleditlinea.fec3.name }   
                                    label=      { confPantalla.edirap.controles.modaleditlinea.fec3.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.fec3.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.fec3.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.fec3.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.fec3.readonly }        
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.fec3.disabled }
                                    change=     { e => handleInputModal(e, saveFec3Lin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1Lin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.nom1.id }   
                                    type=       { confPantalla.edirap.controles.modaleditlinea.nom1.type }  
                                    name=       { confPantalla.edirap.controles.modaleditlinea.nom1.name }   
                                    label=      { confPantalla.edirap.controles.modaleditlinea.nom1.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.nom1.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.nom1.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.nom1.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.nom1.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.nom1.disabled }
                                    change=     { e => handleInputModal(e, saveNom1Lin) }
                                    onBlur=     {null} 
                                />
                                <FormInput                                                        
                                    estadoForm= { "" }
                                    value=      { nom1EnLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.nom1_en.id }   
                                    type=       { confPantalla.edirap.controles.modaleditlinea.nom1_en.type }  
                                    name=       { confPantalla.edirap.controles.modaleditlinea.nom1_en.name }   
                                    label=      { confPantalla.edirap.controles.modaleditlinea.nom1_en.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.nom1_en.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.nom1_en.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.nom1_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.nom1_en.readonly }        
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.nom1_en.disabled }
                                    change=     { e => handleInputModal(e, saveNom1EnLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <FormRow>
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.notas.id }   
                                    name=       { confPantalla.edirap.controles.modaleditlinea.notas.name }
                                    rows=       { confPantalla.edirap.controles.modaleditlinea.notas.rows }      
                                    label=      { confPantalla.edirap.controles.modaleditlinea.notas.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.notas.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.notas.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.notas.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.notas.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.notas.disabled }
                                    change=     { e => handleInputModal(e, saveNotasLin) }
                                    onBlur=     {null} 
                                />                            
                                <TextArea                                                        
                                    estadoForm= { "" }
                                    value=      { notasEnLin }
                                    loading=    { loadingActionModal ? true : false }
                                    id=         { confPantalla.edirap.controles.modaleditlinea.notas_en.id }   
                                    name=       { confPantalla.edirap.controles.modaleditlinea.notas_en.name }
                                    rows=       { confPantalla.edirap.controles.modaleditlinea.notas_en.rows }      
                                    label=      { confPantalla.edirap.controles.modaleditlinea.notas_en.label }                                                       
                                    placeholder={ confPantalla.edirap.controles.modaleditlinea.notas_en.placeholder }    
                                    col=        { confPantalla.edirap.controles.modaleditlinea.notas_en.col } 
                                    required=   { confPantalla.edirap.controles.modaleditlinea.notas_en.required }
                                    readonly=   { docBloqueado == true ? "readonly" : confPantalla.edirap.controles.modaleditlinea.notas_en.readonly }
                                    disabled=   { docBloqueado == true ? "disabled" : confPantalla.edirap.controles.modaleditlinea.notas_en.disabled }
                                    change=     { e => handleInputModal(e, saveNotasEnLin) }
                                    onBlur=     {null} 
                                />
                            </FormRow>
                            <UplmPlusBtn
                                idReg={idLin}
                                id={ confPantalla.edirap.controles.modaleditlinea.uplmplusbtn.id }
                                getAdj={confPantalla.edirap.controles.modaleditlinea.uplmplusbtn.getadj}
                                saveAdj={confPantalla.edirap.controles.modaleditlinea.uplmplusbtn.saveadj}
                                estadoForm= { docBloqueado == true ? "readonly" : "" }                                    
                                col={12}
                                readonly={ confPantalla.edirap.controles.modaleditlinea.uplmplusbtn.readonly }
                                traduction={confPantalla.config.trad.components}                                                            
                                datatable={ confPantalla.edirap.controles.modaleditlinea.uplmplusbtn.datatable }
                                select={ confPantalla.edirap.controles.modaleditlinea.uplmplusbtn.select }
                                noBtn={true}
                                noModal={true}
                                saveAdjuntosParam={saveAdjuntos}
                            />
                            {   loadingActionModal ? 
                                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                        <Spinner animation="border" />
                                    </div>
                                :
                                null
                            }                            
                        </Modal.Body>
                        <Modal.Footer>
                            <div className='text-right'>
                                <button 
                                        className="btn btn-success mt-1 mr-1"
                                        onClick={ accionBtnEditLinea }
                                        disabled={ docBloqueado == true ? true : false}                                        
                                >
                                    {confPantalla.edirap.controles.modaleditlinea.btnaceptar.title}
                                </button>
                                <button 
                                        className="btn btn-danger mt-1"
                                        onClick={ () => saveShowModalEditLinea(false) }                                        
                                >
                                    {confPantalla.edirap.controles.modaleditlinea.btncancelar.title}
                                </button>                                            
                            </div>
                        </Modal.Footer>                            
                    </Modal>
                    :
                        null
                }
                
            </section>
        </div>
        <Footer />        
        </div>

    );

}
export default Edirap